const ScrollOut = require("../scroll_out/");
const {DOM_foreach} = require('../util');

module.exports.scrollout_init = (option={}) =>{
    // 検証その１の実装
    if(ScrollOut === void(0)) {
        console.warn("[Warning]ScollOut plugin is not load, This page may not displayed properly.");

        DOM_foreach('[data-preset-class-before-scoll-in]',(DOM_found_element)=>{
            let presetClass=DOM_found_element.dataset['presetClassBeforeScollIn'] || 'before-scroll-in';
            DOM_found_element.classList.remove(presetClass);
        });
        DOM_foreach('.before-scroll-in',(DOM_found_element)=>{
            DOM_found_element.classList.remove('before-scroll-in');
        });

        return;
    }

    let so = ScrollOut({
        once:true,
        scrollingElement: "#main-scroll-area",
        onShown:(e,ctx)=>{
            let adding_class=('addClassScrollIn' in e.dataset);
            let removing_class=('removeClassScrollIn' in e.dataset);
            
            //console.log(`onShown:${e.id}`);

            if('special_scrollin' in option){

                // FIXME:ちゃんとしたやり方に書き換える
                option['special_scrollin'](e,ctx,false);

            }

            if([adding_class,removing_class].some((e)=>e) === false) return;

            if('addClassScrollIn' in e.dataset){
                let raw_addClass=e.dataset['addClassScrollIn'];
                let ary_addClass;
    
                if(raw_addClass == false) {
                    console.warn('----------------------------------------------------------');
                    console.warn("[Warning]data-add-class-scroll-in has falsy value. skiped.");
                    console.warn(e);
                    console.warn('----------------------------------------------------------');
                } else {
                    ary_addClass = raw_addClass.split(',');
    
                    for(var class_to_add of ary_addClass){
                        e.classList.add(class_to_add);
                    }
        
                }
            }

            if('removeClassScrollIn' in e.dataset){
                let raw_removeClass=e.dataset['removeClassScrollIn'];
                let ary_removeClass;
    
                if(raw_removeClass == false) {
                    console.warn('----------------------------------------------------------');
                    console.warn("[Warning]data-add-class-scroll-in has falsy value. skiped.");
                    console.warn(e);
                    console.warn('----------------------------------------------------------');
                } else {
                    ary_removeClass = raw_removeClass.split(',');
    
                    for(var class_to_remove of ary_removeClass){
                        e.classList.remove(class_to_remove);
                    }
                }
    
            }
        },
        onHidden:(e,ctx)=>{
            let adding_class=('addClassScrollOut' in e.dataset);
            let removing_class=('removeClassScrollOut' in e.dataset);

            //console.log("onHidden");
            if('special_scrollin' in option){

                // FIXME:ちゃんとしたやり方に書き換える
                option['special_scrollin'](e,ctx,true);

            }
            
            if([adding_class,removing_class].some((e)=>e) === false) return;

            if('addClassScrollOut' in e.dataset){
                let raw_addClass=e.dataset['addClassScrollOut'];
                let ary_addClass;
    
                if(raw_addClass == false) {
                    console.warn('----------------------------------------------------------');
                    console.warn("[Warning]data-add-class-scroll-out has falsy value. skiped.");
                    console.warn(e);
                    console.warn('----------------------------------------------------------');
                } else {
                    ary_addClass = raw_addClass.split(',');
    
                    for(var class_to_add of ary_addClass){
                        e.classList.add(class_to_add);
                    }
    
                
                }
    
            }

            if('removeClassScrollOut' in e.dataset){
                let raw_removeClass=e.dataset['removeClassScrollOut'];
                let ary_removeClass;
                if(raw_removeClass == false) {
                    console.warn('----------------------------------------------------------');
                    console.warn("[Warning]data-add-class-scroll-out has falsy value. skiped.");
                    console.warn(e);
                    console.warn('----------------------------------------------------------');
                } else {
                    ary_removeClass = raw_removeClass.split(',');
                    
                    for(var class_to_remove of ary_removeClass){
                        e.classList.remove(class_to_remove);
                    }
                }
    
            }

        }
    });    
}
